import {
  Skeleton,
  TextField,
  Typography,
  Input,
  InputAdornment,
  Button,
  IconButton,
  Container,
} from '@mui/material';
import React, { useState, useMemo } from 'react';
import { AdminUsersDTO } from '../../../api/DTO';
import { AdminBalanceContainer } from './AdminBalance.styled';
import { useAdminUsersData } from '../../../api/apiHooks';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import { FormProvider, useForm } from 'react-hook-form';
import { DataGrid } from '@mui/x-data-grid';
import { ADMIN_BALANCE_GRID_COLUMNS } from './utils';
import InputMask from 'react-input-mask';
import PhoneMaskInput from '../../PhoneMaskInput'; // Импортируй PhoneMaskInput

const AdminBalance = () => {
  const methods = useForm();
  const { handleSubmit } = methods;

  const [userPhone, setUserPhone] = useState('');
  const [searchedUserInfo, setSearchedUserInfo] = useState<AdminUsersDTO>();
  const [isLoading, setIsLoading] = useState(false);
  const [amount, setAmount] = useState('');
  const { fetchUserInfo, patchUserBalance } = useAdminUsersData();

  const isAdmin = localStorage.getItem('role_id') === '1';

  const onSubmit = () => {
    setIsLoading(true);
    fetchUserInfo(userPhone)
      .then((data) => setSearchedUserInfo(data))
      .catch(() => {})
      .finally(() => setIsLoading(false));
  };

  const handleBalanceChangePost = () => {
    if (!searchedUserInfo) return;
    patchUserBalance({
      amount: amount,
      username: searchedUserInfo.username,
      id: searchedUserInfo.id,
    })
      .then((data) => {
        setSearchedUserInfo(data);
        setAmount('');
      })
      .catch(() => {})
      .finally(() => setIsLoading(false));
  };

  const balanceHistoryColumns = useMemo(() => ADMIN_BALANCE_GRID_COLUMNS, []);
  const handleUserPhoneChange = (e: React.ChangeEvent<HTMLInputElement>) =>
    setUserPhone(e.target.value);

  const handleAmountChange = (e: React.ChangeEvent<HTMLInputElement>) => setAmount(e.target.value);

  if (!isAdmin) {
    return (
      <Container sx={{ marginTop: '100px' }}>
        <Skeleton height={60} />
        <Skeleton height={60} />
        <Skeleton height={60} />
        <Skeleton height={60} />
        <Skeleton height={60} />
      </Container>
    );
  }

  return (
    <FormProvider {...methods}>
      <AdminBalanceContainer>
        <Typography
          variant='h6'
          sx={{ textAlign: 'center' }}
          gutterBottom
        >
          Изменение баланса пользователя
        </Typography>

        <form onSubmit={handleSubmit(onSubmit)}>
          <TextField
            label='Телефон'
            name='userPhone'
            value={userPhone}
            placeholder='Телефон пользователя'
            onChange={handleUserPhoneChange}
            InputProps={{
              inputComponent: PhoneMaskInput as any,
              endAdornment: (
                <InputAdornment position='end'>
                  <IconButton type='submit'>
                    <SearchOutlinedIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
            fullWidth
          />
        </form>

        {isLoading ? (
          <>
            <Skeleton
              width={'100%'}
              height={48}
            />

            <Skeleton
              width={'100%'}
              height={48}
            />
          </>
        ) : (
          <>
            {searchedUserInfo && (
              <>
                <TextField
                  label='Имя'
                  fullWidth
                  variant='standard'
                  value={searchedUserInfo.name}
                  disabled
                />
                <TextField
                  label='Текущий баланс'
                  fullWidth
                  variant='standard'
                  value={searchedUserInfo.balance}
                  disabled
                />

                {/* @ts-ignore */}
                <InputMask
                  mask='99999'
                  maskChar={null}
                  value={amount}
                  onChange={handleAmountChange}
                  error={amount?.length > 5}
                >
                  {/* @ts-ignore */}
                  {(inputProps) => (
                    <TextField
                      label='Сумма для начисления'
                      {...inputProps}
                    />
                  )}
                </InputMask>

                <Button
                  onClick={handleBalanceChangePost}
                  variant='contained'
                >
                  Начислить
                </Button>

                <Typography
                  variant='subtitle2'
                  sx={{ textAlign: 'center', fontSize: 16 }}
                  gutterBottom
                >
                  История изменений
                </Typography>

                <DataGrid
                  getRowId={(row) => row.id}
                  rows={searchedUserInfo.balance_history ?? []}
                  columns={balanceHistoryColumns}
                  isRowSelectable={() => false}
                  disableColumnFilter
                  disableColumnMenu
                  sx={{ height: '670px', alignSelf: 'flex-start', width: '100%' }}
                />
              </>
            )}
          </>
        )}
      </AdminBalanceContainer>
    </FormProvider>
  );
};

export default AdminBalance;
